const CoursesPage = () => {
  return <div className="container chat-page">Courses Page!</div>;
};

export default CoursesPage;
